import { updatePositions, setUpCollapsibleForm } from "../../../util/methods"
import { initSortable } from "../../../util/sortable"

$(document).on("turbolinks:load", function () {
  var $bundleTiersContainer = $("#js-productBundle-tiers")

  if ($bundleTiersContainer.length > 0) {
    var $bundleTiers = $(".js-productBundle-tier")

    // sortability of tiers
    initSortable(
      $bundleTiersContainer[0],
      ".js-productBundle-tier",
      ".draggable-handle",
      function () {
        updatePositions($(".js-productBundle-tier:visible"))
      }
    )

    // sortability of tier_items in each tier
    $bundleTiers.each(function () {
      initializeTierItemsSortable($(this))
    })

    $(".js-productBundle-tierItem-select").each(function () {
      initializeTierItemSelect(this)
    })

    $bundleTiersContainer
      .on("cocoon:after-insert", function (e, $insertedItem) {
        if ($insertedItem.hasClass("js-productBundle-tier")) {
          setUpCollapsibleForm($insertedItem)
          updatePositions($(".js-productBundle-tier:visible"))
          initializeTierItemsSortable($insertedItem)
        } else if ($insertedItem.hasClass("js-productBundle-tierItem")) {
          initializeTierItemSelect(
            $insertedItem.find(".js-productBundle-tierItem-select")[0]
          )
          updatePositions($(".js-productBundle-tierItem:visible"))
        }
      })
      .on("cocoon:after-remove", function (e, $removedItem) {
        if ($removedItem.hasClass("js-productBundle-tier")) {
          updatePositions($(".js-productBundle-tier:visible"))
        } else if ($removedItem.hasClass("js-productBundle-tierItem")) {
          updatePositions($(".js-productBundle-tierItem:visible"))
        }
      })
  }
})

function initializeTierItemsSortable($el) {
  var $bundleTierItemsContainer = $el.find(
    ".js-productBundle-tier-items-container"
  )

  initSortable(
    $bundleTierItemsContainer[0],
    ".js-productBundle-tierItem",
    ".draggable-handle",
    function () {
      updatePositions($(".js-productBundle-tierItem:visible"))
    }
  )
}

function initializeTierItemSelect(el) {
  var $el = $(el)
  var $form = $el.closest(".js-productBundle-form")
  $el.select2({
    ajax: {
      url: "/api/site/admin/product_bundles/bundle_items",
      dataType: "json",
      delay: 250,
      data: function (params) {
        return {
          q: params.term,
          bundle_id: $form.data("id"),
        }
      },
      processResults: function (data) {
        return {
          results: data.results,
        }
      },
      cache: true,
    },
    minimumInputLength: 0,
    placeholder: "Select a product ...",
    width: "100%",
  })
}
